var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2925 6.29376C8.9025 6.68376 8.9025 7.31376 9.2925 7.70376L13.1725 11.5838L9.2925 15.4638C8.9025 15.8538 8.9025 16.4838 9.2925 16.8738C9.6825 17.2638 10.3125 17.2638 10.7025 16.8738L15.2925 12.2838C15.6825 11.8938 15.6825 11.2638 15.2925 10.8738L10.7025 6.28376C10.3225 5.90376 9.6825 5.90376 9.2925 6.29376Z",
    fill: "currentColor"
  })));
};
export default SvgChevronRight;